import { authenticatedInstance } from '../index/index.service';
import { extractServiceErrorMessage } from '../shared/service-error.util';
import type {
  ClosedSessionReconcileOption,
  AdminSessionsPage,
  AdminSessionsQuery,
} from 'shared-models/browser';

export type {
  AdminSessionAuditView,
  ClosedSessionReconcileOption,
  AdminSessionsPage,
  AdminSessionsQuery,
  AdminSessionsSortKey,
} from 'shared-models/browser';

class AdminSessionsService {
  async list(query: AdminSessionsQuery = {}): Promise<AdminSessionsPage> {
    try {
      const response = await authenticatedInstance.get<AdminSessionsPage>('/sessions/admin/audit', { params: query });
      return response.data;
    } catch (error: unknown) {
      throw new Error(extractServiceErrorMessage(error, 'טעינת ההפעלות נכשלה'));
    }
  }

  async listClosedReconcileOptions(tenantId: string): Promise<ClosedSessionReconcileOption[]> {
    try {
      const response = await authenticatedInstance.get<ClosedSessionReconcileOption[]>(
        `/sessions/admin/tenant/${tenantId}/closed-reconcile-options`,
      );
      return response.data;
    } catch (error: unknown) {
      throw new Error(extractServiceErrorMessage(error, 'טעינת ההפעלות נכשלה'));
    }
  }
}

export const adminSessionsService = new AdminSessionsService();
